<template lang="pug">
feathers-vuex-find(service="vw-label-campaign" :query="dataQuery" :fetch-query="fetchQuery" watch="query")
    v-card(slot-scope="{ items: desserts, pagination: serverPagination, isFindPending }")
        v-card-title Label Campaign
            v-spacer
            v-text-field(v-model="searchUser" append-icon="mdi-magnify" label="Search" single-line hide-details)
        v-data-table(
            :headers="headers"
            :loading="isFindPending"
            :items="isFindPending ? [] : desserts"
            :options.sync="pagination"
            :server-items-length="!serverPagination ? 0 : serverPagination.mostRecent.total"
            :footer-props="{ showCurrentPage: true, itemsPerPageOptions: [15, 20, 25, 30, 35, 40] }"
            loading-text="Fetching Data..."
        )   
            template(v-slot:item.title="{ item }")
                div(style="display: flex;")
                    v-avatar(size="40" tile)
                        v-img(style="vertical-align: middle;" :src="item.music_cover_thumb")
                    | &nbsp;&nbsp;&nbsp;
                    div(style="flex: 1;")
                        span.user-fullname {{ item.user.result['fname'] }} {{ item.user.result['lname'] }}
                        br
                        a.user-link(:href="`https://www.breakinghits.app/${item.user.result.url}`" :target="`__user-${item.id}`" v-html="item.title")
                        
            template(v-slot:item.audio="{ item }")
                audio(controls controlsList="nodownload" style="height: 30px;")
                    source(:src="`https://api.breakinghits.com/player/audio/${item.id}`" type="audio/mpeg")

            template(v-slot:item.date_added="{ item }")
                v-chip(small :color="item.featured === 1 ? 'orange' : 'green'" outlined) {{ item.date_added | dateFormat }}

            template(v-slot:item.avg="{ item }")
                div {{ item.rating_avg | toRating }} 
                    span.small-text {{ item.number_vote }} Opinions
                div.small-text.extra-text Avg. Playtime: {{ item.listen_avg | toTimeDuration }}

            
            //- template(v-slot:item.date_featured="{ item }")
            //-     v-chip(v-if=" small color="orange" outlined) {{ item.date_added | dateFormat }}

            template(v-slot:item.featured="{ item }")
                featured-button(:item="item")
            
</template>

<script>
import moment from 'moment';
import FeaturedButton from './components/FeaturedButton.vue';

export default {
    data() {
        return {
            searchUser: '',
            headers: [
                // {
                //     text: 'ID',
                //     align: 'start',
                //     sortable: false,
                //     width: 60,
                //     value: 'id'
                // },
                {
                    text: '',
                    align: 'center',
                    sortable: false,
                    width: 100,
                    value: 'featured'
                },
                {
                    text: 'AV. Rating / Number of Participants',
                    align: 'center',
                    sortable: false,
                    width: 150,
                    value: 'avg'
                },
                {
                    text: 'Title',
                    align: 'start',
                    sortable: false,
                    value: 'title'
                },
                {
                    text: 'Audio',
                    align: 'start',
                    sortable: false,
                    value: 'audio'
                },
                // {
                //     text: 'Date Featured',
                //     align: 'start',
                //     sortable: false,
                //     value: 'date_featured'
                // },
                {
                    text: 'Date Added',
                    align: 'end',
                    sortable: false,
                    value: 'date_added'
                }
            ],
            pagination: {
                page: 1,
                itemsPerPage: 15,
                sortBy: [ 'id' ],
                sortDesc: [ true ]
            },
            query: {},
        };
    },
    filters: {
        dateFormat(date) {
            if(date) {
                return moment(date).format('lll');
            }

            return 'n/a';
        },
        status(status) {
            switch(status) {
                case 0: return 'Inactive';
                case 1: return 'Active';
            }
        },
        toRating(value) {
            return parseFloat(value).toFixed(1);
        },
        toTimeDuration(value) {
            const seconds = parseFloat(value) / 1000;
            const  minutes = ~~(seconds / 60);
            const extraSeconds = seconds % 60;
            return `${String(minutes).padStart(2, '0')}:${extraSeconds.toFixed(0).padStart(2, '0')}`;
        }
    },
    computed: {
        extendedQuery() {
            if(this.user) {
                return {
                    // id: { $nin: [this.user.id] }
                };
            }
            return null;
        },
        searchQuery() {
            if(this.searchUser) {
                return {
                    $or: [
                        { title: { $like: `%${this.searchUser}%` } },
                    ]
                };
            }
            return null;
        },
        searchDataQuery() {
            if(this.searchUser) {
                return {
                    $or: [
                        { title: { $regex: new RegExp(`.*${this.escapeRegex(this.searchUser)}.*`, 'gi') } },
                    ]
                };
            }
            return null;
        },
        sortingQuery() {
            if(this.pagination.sortBy.length !== 0) {
                const $sort = {};
                this.pagination.sortBy.map((item, index) => {
                    switch(item) {
                        case 'fullname':
                            $sort.fname = this.pagination.sortDesc[index] ? -1 : 1;
                            $sort.lname = this.pagination.sortDesc[index] ? -1 : 1;
                            break;
                        default:
                            $sort[item] = this.pagination.sortDesc[index] ? -1 : 1;
                    }
                    
                });
                return { $sort };
            }
            return null;
        },
        dataQuery() {
            return {
                ...this.query,
                ...this.extendedQuery,
                ...this.searchDataQuery,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            };
        },
        fetchQuery() {
            return Object.assign({}, {
                ...this.query,
                ...this.extendedQuery,
                // $populate: true
            }, {
                ...this.searchQuery,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            });
        },
    },
    methods: {
        escapeRegex(string) {
            return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
        },
    },
    components: {
        FeaturedButton
    }
}
</script>

<style>
.user-link {
    text-decoration: none;
    color: black !important;
}
.user-link:hover {
    text-decoration: underline;
}
.user-fullname {
    color: grey;
}
.small-text {
    color: grey;
    font-size: 10px;
    margin-left: 5px;
}
.extra-text {
    color: chocolate;
}
</style>